import { render, staticRenderFns } from "./MyMenuMediaInput.vue?vue&type=template&id=4f0c1d1a&"
import script from "./MyMenuMediaInput.vue?vue&type=script&lang=js&"
export * from "./MyMenuMediaInput.vue?vue&type=script&lang=js&"
import style0 from "./MyMenuMediaInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports